export default {
  intro: 'Bitte füllen Sie die Kreditkartendaten aus!',
  ccNumber: 'Kartennummer',
  expDate: 'Ablaufdatum',
  cvv: 'CVV',
  submit: 'Abschicken',
};
